<template>
    <pop-up
        textAlign='left'
        :title="$t('share.popUp.failed')"
        :description="$t('share.popUp.failedReason')"
        @cancel="cancelShare"
        :buttons="buttons">
    </pop-up>
</template>
<script>
import { requestToApp } from '@/api/app';
import popUp from '@/components/popUp';

export default {
    components: {
        popUp
    },
    data () {

        return {
            buttons: [
                {
                    click: 'cancel',
                    type: 'primary',
                    text: this.$t( 'share.popUp.confirm' )
                }
            ]
        };

    },
    methods: {
        cancelShare () {

            requestToApp( 'cancelBackToApp' );

        }
    }
};
</script>



// WEBPACK FOOTER //
// src/view/share/codeExpried.vue